var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.iconContainer,
    style: {
      'background-image': 'url(\'' + encodeURI(_vm.getFileName) + '\')'
    }
  }, [_vm.fileExtension ? _c('span', {
    class: _vm.$style.fileExtensionText,
    style: {
      'font-size': _vm.getExtensionFontSize
    }
  }, [_vm._v(" " + _vm._s(_vm.getFileExtension) + " ")]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }